const tabuleoSubscription = {
  tabuleoSubscriptions: "Tabuléo Subscriptions",
  nbStudentTeacher: "Number of students and teachers",
  getSubscriptionsError:
    "An error occurred while loading Tabuléo subscriptions.",
  getSubscriptionError: "An error occurred while loading the school details.",
  nbrStudent: "Number of students",
  nbrTeacher: "Number of teachers",
};

export default tabuleoSubscription;
